import { render, staticRenderFns } from "./garantie.vue?vue&type=template&id=0b3a3049&scoped=true"
import script from "./garantie.vue?vue&type=script&lang=ts"
export * from "./garantie.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b3a3049",
  null
  
)

export default component.exports